import PropTypes from "prop-types";
import React, { useState } from "react";
import { Box } from "@mui/material";
import ListSelect from "../../../components/Utils/ListSelect";
import { populateQPUsers } from "../../../components/Api/Post";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}
CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

export default function PopulateQP(props) {
	const { value, token, terms, termValue, termNumber, handleChangeTerm } = props;
	const [populateQPLoading, setPopulateQPLoading] = useState(false);
	const [statusMessage, setStatusMessage] = useState("");
	const handlePopulateQP = async () => {
		try {
			setPopulateQPLoading(true);
			setStatusMessage("Populating QP Users, please wait...");
			const response = await populateQPUsers(token, termNumber);
			if (response) {
				setPopulateQPLoading(false);
				setStatusMessage("QP Users populated successfully");
			}
		} catch (error) {
			setPopulateQPLoading(false);
			setStatusMessage("Error populating QP Users", error);
			console.error(error);
		}
	};
	return (
		<CustomTabPanel value={value} index={3}>
			<ListSelect
				className="termSelect"
				list={terms}
				label="Term"
				width="100%"
				value={termValue || ""}
				onChange={handleChangeTerm}
			/>
			<button
				onClick={handlePopulateQP}
				className="px-4 py-2 bg-gray-200 border-gray-400 border-2 rounded-xl hover:bg-gray-600 hover:border-gray-800 hover:text-white"
			>
				Populate QP Users
			</button>
			{populateQPLoading && <div>{statusMessage}</div>}
		</CustomTabPanel>
	);
}
